import React from "react";
import {Routes, Route } from "react-router-dom";
import { ProfileCard } from './pages/profileCard/profileCard.js'


export default function App() {
  return (
      <ProfileCard />
  );
}